import React from 'react';
import { Link } from 'react-router-dom';
import { BsArrowUp } from "react-icons/bs";

const ContentSection = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <>
            <section className="content__area theme-bg pt-90 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="content__item">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon9.png" alt="Dsider" />
                                </div>
                                <h3 className="white-color">1. Operations Forecasting</h3>
                                <p className="white-color">Predict and optimize your NetZero initiatives with unparalleled precision. Our advanced AI models lets you model different scenarios and forecast outcomes. Anticipate challenges, optimize resources, and make data-driven decisions that reduce your carbon footprint. Gain competitive advantage with insights that seamlessly align NetZero targets with economic success!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content__area black-bg-2 pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="content__item">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon10.png" alt="Dsider" />
                                </div>
                                <h3 className="white-color">2. Financial Analysis</h3>
                                <p className="white-color">Gain a comprehensive view of financials and emissions from low-carbon technologies and initiatives with Dsider. Dsider pin-points cost-saving opportunities while optimizing the best path to a future state of NetZero operations. By integrating AI with Economics, we deliver precise forecasting and tailored risk assessments for your business. Make informed decisions that enhance profits and advance your sustainability goals.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content__area pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="content__item">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon11.png" alt="Dsider" />
                                </div>
                                <h3>3. Risk Analysis</h3>
                                <p>Navigate uncertainties with confidence using Dsider's techno-economic and scenario analyses to evaluate disruptions, market shifts, and regulatory changes. Gain real-time insights into risk factors and discover how to effectively scale your initiatives to achieve sustainable NetZero. Transform risk management into a strategic advantage, ensuring resilience and sustainability in an ever-evolving industrial landscape.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content__area theme-bg pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="content__item">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon12.png" alt="Dsider" />
                                </div>
                                <h3 className="white-color">4. Carbon Abatement Analysis</h3>
                                <p className="white-color">Achieve sustainability goals with precision using Dsider's emissions analysis. Our first-principles and AI-based simulations provide a comprehensive assessment of your carbon footprint while identifying key reduction opportunities. Evaluate the impact of various abatement strategies-such as energy efficiency improvements, carbon capture and use, and renewable energy adoption-and select the most effective path to lower emissions. With real-time insights and data-driven recommendations, Dsider empowers you to implement sustainable practices that deliver both environmental and economic benefits.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* this section has a dummy content */}
            <section className="content__area black-bg-2 pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="content__item">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon14.png" alt="Dsider" />
                                </div>
                                <h3 className="white-color">5. Comprehensive Reports</h3>
                                <p className="white-color">Delivering reports is as simple as clicking a button. Select your analyzed scenarios and generate graphs and reports effortlessly.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content__area pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="content__item">
                                <div className="iconBox">
                                    <img src="assets/img/home-icon15.png" alt="Dsider" />
                                </div>
                                <h3>6. Data Integration</h3>
                                <p>Dsider curates data from credible sources to simplify analysis for energy transition and decarbonization. Our advanced platform consolidates diverse data into a cohesive view for techno-economic analysis. By leveraging real-time data and deterministic AI, Dsider bridges the gap between knowledge and data while reducing biases, enabling informed decisions and driving sustainability initiatives. Unlock the full potential of your data with Dsider and supercharge your carbon reduction efforts.</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="text-center mt-50">
                                <Link to="#" className="toTop" onClick={scrollToTop}><BsArrowUp /> Back To Top</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContentSection;